import { NgModule, Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'split-marquee',
    templateUrl: 'split-marquee.template.html',
    styleUrls: ['split-marquee.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitMarquee {
    @Input() item: any;
    @Input() colSize:string;

    private _hideImage:boolean = false;
    private currentTime:number = 0;
    public videoState:string = "in";
    public videoSource:string;

    public get showVideo():boolean{
        if(this.item && this.item.meta && (this.item.meta.video || this.item.meta.video_types))
        {
            this.videoSource = this.item.meta.video ? this.item.meta.video.meta.video_types : this.item.meta.video_types;
            return true;
        }

        return false;
    }

    public set hideImage(val:boolean){
        if(val)
        {
            this.videoState = "in";
        }

        this._hideImage = val;
    }

    public get hideImage():boolean{
        return this._hideImage;
    }

    public handleAnimationComplete(val:boolean) {
        this.hideImage = !val;
    }

    /**
     * split marquee Component
     */
    constructor() {
        //this.subtitle = "Search the list of men and women who helped shape Chickasaw history."
    }

    ngOnInit() {
    }

    public rollCell(){
        if(this.showVideo)
        {
            this.hideImage = true;
        }
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee/marquee-cell/split-marquee/split-marquee.component.ts